import { Container, Typography } from "@mui/material";
import React from "react";

const MainContainer = ({ children, header }) => {
  return (
    <Container
      sx={{
        width: "600px",
        maxWidth: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "space-between",
        gap: "20px",
        paddingBottom:"30px",
      }}
    >
        {header ? <Typography component="h1" variant="" sx={{paddingTop: "20px"}}>{header}</Typography> : true}
      {children}
    </Container>
  );
};

export default MainContainer;
